module.exports = __webpack_public_path__ + "img/googlePlay-but.4fac0c03.png";